<template>
  <div class="bonuses-info" v-if="isBonusesInfo && !isCheckout">
    <div class="bonuses-item" v-if="bonusesInfo.current_purchase_bonuses && !(promocodeInfo && promocodeInfo.codeValue)">
      <span class="bonuses-item__info">{{ $t('credited') }}</span>
      <span class="bonuses-item__info-accent"> +{{ bonusesInfo.current_purchase_bonuses }} {{ [$t('bonus'), $t('bonus-2'), $t('bonus-3')] | Pluralize(bonusesInfo.current_purchase_bonuses) }}</span>
    </div>
    <!--    Проверка на ставку 30% для сотрудников компании-->
    <div class="bonuses-item" v-if="showNextRateInfo">
      <span class="bonuses-item__info">{{ $t('next-bonus') }}</span>
      <span class="bonuses-item__info-accent"> {{ bonusesInfo.next_rate }}%</span>
      <span class="bonuses-item__info"> {{ $t('left') }} </span>
    </div>
    <Loader v-if="showLoader" :is-loading="!!loadingComponents.bonusesInModal"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from '../helpers/Loader'
import CurrencyFormatter from '../../filters/CurrencyFormatter'
import Pluralize from '../../filters/Pluralize'

export default {
  name: 'BonusesInModal',
  components: { Loader },
  props: {
    isCheckout: Boolean
  },
  computed: {
    ...mapState({
      bonusesInfo: state => state.bonuses.bonusesInfo,
      loadingComponents: state => state.checkout.loadingComponents,
      promocodeInfo: state => state.cart.promocodeInfo
    }),
    isBonusesInfo () {
      return this.bonusesInfo && this.bonusesInfo.is_active_bonuses_info
    },
    showLoader () {
      return this.bonusesInfo.current_purchase_bonuses || (this.bonusesInfo.rate && this.bonusesInfo.rate !== this.bonusesInfo.next_rate)
    },
    showNextRateInfo () {
      return this.bonusesInfo.rate && this.bonusesInfo.rate !== this.bonusesInfo.next_rate && this.bonusesInfo.next_rate !== 0 && this.bonusesInfo.next_rate !== null
    }
  },
  filters: {
    CurrencyFormatter,
    Pluralize
  }
}
</script>

<style scoped lang="sass">

.bonuses-info
  position: relative
  width: 100%
  margin-bottom: 30px

.bonuses-item
  font-size: 14px

  &:not(:last-child)
    margin-bottom: 10px

.bonuses-item__info
  color: $nd-label-color
  font-weight: 400 //Rubik 300

.bonuses-item__info-accent
  font-weight: 400
  color: $main-color
</style>
